<template>
  <div class="box" :class="viewMode">

      <PreviewContainer
        v-if="showPreview"
        :data="postData"
        :content="postContent"
        @changeMode="changeMode"
        @enableModal="enableModal"
      />

      <!-- Mostrar contenido -->
      <Container
        class="post-container"
        v-else-if="postData.available"
        :element="postContent"
        :model="model"
        :viewMode="viewMode"
      />
      <!-- Mostrar BLOQUEADO-->
      <BlockedContainer
        v-else-if="showBlocked"
        :data="postData"
        :content="postContent"        
        :model="model"
        :viewMode="viewMode"
      />
      <!-- Mostrar ELSE -->
      <div v-else>
        {{ $t("video_watch.not_available") }}
      </div>

  </div>
</template>
<script>
import Container from "./Container.vue";
import BlockedContainer from "./BlockedContainer.vue";
import PreviewContainer from "./PreviewContainer.vue";

export default {
  name: "PostSimple",
  components: {
    Container,
    BlockedContainer,
    PreviewContainer,
  },
  props: {
    postData: {},
    postContent: {},
    model: {},
    VideoElementHandler: {},
    viewMode: {
      type: String,
      default: "vertical",
      required: false,
    },
  },
  data() {
    return {
      videoPlayer: null,
    };
  },
  methods: {
    getVideoElementHandler() {
      return this.VideoElementHandler;
    },
    changeMode() {
      this.$emit("changeMode");
    },
    enableModal() {
      this.$emit("enableModal");
    },
  },
  computed: {
    showBlocked() {
      return ["normal", "premium", "free", "tokens"].includes(
        this.postData.front_container
      );
    },
    showPreview() {
      return this.viewMode === "grid";
    },
  },
};
</script>

<style lang="scss" scoped>
.post-container {
  max-width: 100%;
  max-height: 90vh;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
}

.box {
  &.grid {
    width: 100%;
    height: 100%;
  }
}
</style>
